import {doAjax} from "./_ajax";

export enum LogStrategy {
    all = 'all', // Logs every event
    first = 'first', // Logs only first event
    update = 'update', // Updates the logged event if it already exists.
}

export interface ClientEventData {
    pageID: number,
    userSurveyID: number,
    itemID: number,
    type: number,
    data: object,
    clientTime: number,
}

/**
 * Logs a client event which may or may not be tied to a survey page.
 */
export default function (eventType: number, logStrategy: LogStrategy = LogStrategy.all, clientEventData: Partial<ClientEventData>): ClientEventData {
    const date = new Date();
    const clientEventDefaultData: ClientEventData = {
        'pageID': parseInt(<string>$("input[name='hidden-page-id']").val()),
        'userSurveyID': parseInt(<string>$("input[name='hidden-user-survey-id']").val()),
        'itemID': null,
        'type': eventType,
        'data': null,
        'clientTime': date.getTime()
    };
    const clientEventMergedData: ClientEventData = $.extend({}, clientEventDefaultData, clientEventData);

    const loggingUrl = $('#log-client-event-url').val() + '/logStrategy/' + logStrategy;
    // No timeout as resposes can get delayed when clicking fast through radio buttons
    doAjax({url: loggingUrl, data: clientEventMergedData, timeout: null});

    return clientEventMergedData;
}
